<template>
  <base-layout>
    <template #breadcrumbs>
      <ui-breadcrumbs title="Пользователи"/>
    </template>
    <div class="mb-3">
      <div class="d-flex justify-content-between flex-nowrap">
        <el-input
          v-model="quickFilter"
          placeholder="Быстрый поиск"
          prefix-icon="el-icon-search"
          @input="quickSearch"
        />
      </div>
    </div>
    <div class="mb-3 d-flex justify-content-end">
      <el-button
        icon="el-icon-plus"
        type="primary"
        size="small"
        @click="add"
      >
        Создать пользователя
      </el-button>
    </div>
    <div class="bg-white shadow-sm">
      <el-table
        v-loading="loading"
        :data="users.data"
        :default-sort="defaultSort"
        class="w-100"
        @sort-change="sortChange"
        @update:loading="loading = $event"
      >
        <el-table-column width="64"/>
        <el-table-column
          prop="name"
          label="ФИО"
          sortable
        />
        <el-table-column
          prop="email"
          label="E-Mail"
          sortable
        />
        <el-table-column
          label="Месторождения"
        >
          <template #default="scope">
            <el-tag
              class="m-1"
              v-for="item in scope.row.places"
              :key="item"
              type="primary"
            >
              {{ item }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="reports"
          label="Права на запросы"
        >
          <template #default="scope">
            <el-tag
              class="m-1"
              v-for="item in scope.row.reports"
              :key="item"
              type="success"
            >
              {{ this.reports[item]?.title }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="Запись шаблонов"
          prop="template_save_access"
          style="word-wrap: break-word;"
          header-align="center"
        >
          <template #default="scope">
            <div style="text-align: center">
              <el-button
                circle
                :type="scope.row.template_save_access ? 'success' : ''"
                :icon="scope.row.template_save_access ? 'el-icon-check' : 'el-icon-minus'"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Администратор"
          prop="is_admin"
          header-align="center"
        >
          <template #default="scope">
            <div style="text-align: center">
              <el-button
                circle
                :type="scope.row.is_admin ? 'primary' : ''"
                :icon="scope.row.is_admin ? 'el-icon-check' : 'el-icon-minus'"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Действия">
          <template #default="scope">
            <el-button
              size="small"
              icon="el-icon-edit"
              @click="handleEdit(scope.$index, scope.row)"
            />
            <el-button
              size="small"
              icon="el-icon-delete"
              type="danger"
              @click="deleteClick(scope.row.id)"
            />
          </template>
        </el-table-column>
        <slot/>
      </el-table>
    </div>
  </base-layout>
</template>

<script>
import moment from 'moment';
import BaseLayout from '@/Layouts/BaseLayout';
import UiBreadcrumbs from '@/components/Ui/UiBreadcrumbs';

export default {
  name: 'Users',
  components: {
    UiBreadcrumbs,
    BaseLayout,
  },
  props: {
    filter: {
      type: Object,
      default: () => {},
    },
    reports: {
      type: Object,
      required: true,
    },
    places: {
      type: Array,
      required: true,
    },
    users: {
      type: Object,
      required: true,
    },
    sort: {
      type: String,
      default: 'id-desc',
    },
  },
  data() {
    return {
      form: this.$inertia.form({role: 1}),
      loading: false,
      quickFilter: this.filter.name ?? '',
      debounceTimeout: 300,
    };
  },
  methods: {
    deleteClick(userId) {
      this.$inertia.delete(route('users.destroy', userId), {
        onSuccess: () => {
          this.$notify.success({
            title: 'Успешно',
            message: 'Удаление было совершено успешно!',
          });
        },
        onError: (errors) => {
          this.$notify.error({
            title: 'Ошибка',
            message: errors.exeption[0],
          });
        },
      });
    },
    add() {
      return this.$inertia.visit(route('users.create'));
    },
    defaultSort() {
      if (this.$page.props.sort) {
        const [prop, order] = this.$page.props.sort.split('-');
        return {prop, order};
      }
      return {prop: 'id', order: 'ascending'};
    },
    handleEdit(index, row) {
      return this.$inertia.visit(location.href + '/' + row.id + '/edit')
    },
    timeFormat(str) {
      return str ? moment(String(str)).format('DD.MM.YYYY hh:mm') : str;
    },
    quickSearch() {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => this.doQuickSearch(), this.debounceTimeout);
    },
    prepareData() {
      const data = {};
      if (this.quickFilter) {
        data.filter = {name: this.quickFilter};
      }
      return data;
    },
    refreshData(data) {
      this.$inertia.replace(route(route().current()), {
        method: 'get',
        data,
        replace: false,
        preserveState: true,
        preserveScroll: false,
        onBefore: () => {
          this.loading = true;
        },
        onFinish: () => {
          this.loading = false;
        },
      });
    },
    doQuickSearch() {
      this.refreshData(this.prepareData());
    },
    sortChange(column) {
      const data = this.prepareData();
      if (column.prop) {
        data.sort = `${column.prop}-${column.order}`;
      }
      this.refreshData(data);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
